import React from 'react';
import { Link } from 'react-router-dom';
import { Clock, ArrowRight, Newspaper } from 'lucide-react';
import { Card } from './ui/card';
import { Badge } from './ui/badge';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';

export const formatBlogDate = (value) => value ? new Date(value).toLocaleDateString('fr-FR', { day: 'numeric', month: 'long', year: 'numeric' }) : '';
export const coverSrc = (url) => (url ? (url.startsWith('http') ? url : `${BACKEND_URL}${url}`) : null);

export function BlogCard({ post, compact = false }) {
  const src = coverSrc(post.cover_url);
  return (
    <Link to={`/blog/${post.slug}`} className="group block h-full focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[hsl(var(--ring))] rounded-2xl" data-testid="blog-card">
      <Card className="h-full overflow-hidden border border-border bg-card hover:shadow-md hover:-translate-y-0.5 transition-[transform,box-shadow] duration-200 flex flex-col">
        <div className={`relative ${compact ? 'aspect-[16/9]' : 'aspect-[16/10]'} bg-[hsl(var(--brand-mint))]/50 overflow-hidden`}>
          {src ? (
            <img src={src} alt={post.title} loading="lazy" className="w-full h-full object-cover group-hover:scale-[1.03] transition-transform duration-300" />
          ) : (
            <div className="w-full h-full flex items-center justify-center"><Newspaper className="h-10 w-10 text-[hsl(var(--primary))]/50" /></div>
          )}
          <Badge className="absolute top-3 left-3 bg-card/90 text-foreground hover:bg-card/90 backdrop-blur text-[11px]" data-testid="blog-card-category">{post.category_label}</Badge>
        </div>
        <div className="p-5 flex flex-col flex-1">
          <div className="flex items-center gap-3 text-xs text-muted-foreground mb-2">
            <time dateTime={post.published_at}>{formatBlogDate(post.published_at)}</time>
            <span className="inline-flex items-center gap-1"><Clock className="h-3 w-3" /> {post.reading_time_min} min</span>
          </div>
          <h3 className="font-['Space_Grotesk'] font-semibold text-lg leading-snug mb-2 group-hover:text-[hsl(var(--primary))] transition-colors" data-testid="blog-card-title">{post.title}</h3>
          {!compact && <p className="text-sm text-muted-foreground leading-relaxed line-clamp-3 flex-1">{post.excerpt}</p>}
          <span className="mt-4 inline-flex items-center gap-1 text-sm font-medium text-[hsl(var(--primary))]">Lire l'article <ArrowRight className="h-4 w-4 group-hover:translate-x-0.5 transition-transform" /></span>
        </div>
      </Card>
    </Link>
  );
}
